import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateArrayModel, StateModel } from "../../models/StateModel";

const initialStateState: StateArrayModel = {
  all_States: [],
  particular_State: {
    stateName: "",
    stateCode: "",
    countryCode: "",
  },
  isStatesFetching: false,
};
const StateSlice = createSlice({
  name: "State",
  initialState: initialStateState,
  reducers: {
    setStates(state, action: PayloadAction<StateModel[]>) {
      state.all_States = action.payload;
    },
    resetStates(state) {
      state.all_States = initialStateState.all_States;
    },
    setParticularState(state, action: PayloadAction<StateModel>) {
      state.particular_State = action.payload;
    },
    setIsStatesFetching(state, action: PayloadAction<boolean>) {
      state.isStatesFetching = action.payload;
    },
  },
});
export default StateSlice;
